import { useMemo } from 'react';
import { SchedulerDayColumn } from '@lp/features/Scheduler/types';
import { getShiftSiblingsMap } from '@lp/features/Scheduler/utils';
import { getOMSSiblingData } from '@lp/features/Scheduler/SchedulerOMS/utils';
import { OMSResource, OMSResourcesWithShifts, OMSShiftType } from '@/api/apis/resources/schedule';

export const useOMSShiftSiblingMaps = (
  dayCols: SchedulerDayColumn[],
  userList: OMSResource[],
  shiftsData: OMSResourcesWithShifts,
) => {
  const siblingMaps: Record<string, ReturnType<typeof getShiftSiblingsMap>> = useMemo(() => {
    return userList.reduce(
      (acc, u) => ({ ...acc, [u?.id]: getShiftSiblingsMap(dayCols, shiftsData[u?.id]?.days, getOMSSiblingData) }),
      {},
    );
  }, [dayCols, userList, shiftsData]);

  return siblingMaps;
};

type DayTotals = {
  slot1: number;
  slot2: number;
};

export const useOMSOnCallDayTotalsMap = (
  dayCols: SchedulerDayColumn[],
  userList: OMSResource[],
  shiftsData: OMSResourcesWithShifts,
) => {
  return useMemo(() => {
    const totals = new Map<string, DayTotals>();

    dayCols.forEach((column) => {
      const dayTotals: DayTotals = {
        slot1: 0,
        slot2: 0,
      };

      userList.forEach((user) => {
        const shift = shiftsData[user.id]?.days?.[column.key];

        if (shift?.slot1?.shiftType === OMSShiftType.OnCall) dayTotals.slot1 += 1;
        if (shift?.slot2?.shiftType === OMSShiftType.OnCall) dayTotals.slot2 += 1;
      });

      totals.set(column.key, dayTotals);
    });

    return totals;
  }, [dayCols, shiftsData, userList]);
};
